export default __webpack_public_path__ + "media/zurb/img/icons/favicon/mstile-70x70-1d295d07e857e9e53a1f433d3a8a5584.png";